// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__WL0Dy","footer":"ModalCreateQualiphyProcedure_footer__3KYkL","additionData":"ModalCreateQualiphyProcedure_additionData__2TMNT"};